<template>
  <v-card :hover="true">
    <form ref="form" xs12>
      <v-flex>
        <v-alert
          v-if="alert"
          :type="alert.type"
          dismissible
          v-model="showAlert"
        >
          {{ alert.message }}
        </v-alert>
      </v-flex>
      <v-text-field
        v-model="email"
        v-validate="'required|email'"
        :error-messages="errors.collect('email')"
        data-vv-name="email"
        data-vv-validate-on="change"
        prepend-icon="email"
        color="primary"
        label="Email address"
        type="email"
        required
      ></v-text-field>
      <v-layout align-start row>
        <v-flex xs2><v-btn flat @click="clear">Clear</v-btn></v-flex>
        <v-flex xs4>
          <v-btn
            :loading="loading"
            class="white--text"
            color="primary"
            type="submit"
            @click="submit"
            depressed
          >
            Send
          </v-btn>
        </v-flex>
      </v-layout>
    </form>
  </v-card>
</template>

<script>
import { mapState } from "vuex";

export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      email: "",
      showAlert: false
    };
  },
  methods: {
    clear() {
      this.email = "";
      this.showAlert = false;
      this.$refs.form.reset();
      this.$validator.reset();
    },
    submit(event) {
      event.preventDefault();
      this.$validator.validateAll().then(valid => {
        if (!this.loading && valid) {
          this.$store.dispatch("auth/resetPassword", {
            email: this.email
          });
        }
      });
    }
  },
  computed: mapState("auth", ["alert", "loading"]),
  watch: {
    alert(value) {
      if (value) {
        this.showAlert = true;
      }
    },
    showAlert(value) {
      if (!value) {
        this.$store.commit("auth/setAlert", null);
      }
    }
  }
};
</script>
